import React from "react";
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import Routes from "./Routes";

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" />
      <Routes />
    </AuthProvider>
  );
}

export default App;
